export enum ProjectSettingKey {
  IsAuthenticationEnabled = 'isAuthenticationEnabled',
  UsernameType = 'usernameType'
}
